import React from 'react';
import styles from './ToggleSwitch.css';

function ToggleSwitch(props) {
  return (
    <label className={styles.switch}>
      <input type="checkbox" {...props} />
      <span className={`${styles.slider} ${styles.round}`} />
    </label>
  );
}

export default ToggleSwitch;
